import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "full-width"
}
const _hoisted_2 = {
  key: 0,
  class: "s-mb-lg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_s_input = _resolveComponent("s-input")!
  const _component_yandex_captcha = _resolveComponent("yandex-captcha")!
  const _component_s_banner = _resolveComponent("s-banner")!
  const _component_s_btn = _resolveComponent("s-btn")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_PortalDialog = _resolveComponent("PortalDialog")!

  return (_openBlock(), _createBlock(_component_PortalDialog, {
    modelValue: _ctx.modalShow,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modalShow) = $event)),
    title: "Обратная связь"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_form, {
        ref: "refForm",
        class: "column s-form",
        onSubmit: _ctx.onSubmit
      }, {
        default: _withCtx(() => [
          _createVNode(_component_s_input, {
            modelValue: _ctx.formData.lastName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.lastName) = $event)),
            label: "Фамилия",
            required: "",
            "lazy-rules": "ondemand",
            class: "q-mb-md s-input",
            clearable: "",
            rules: [_ctx.NotEmpty('Пожалуйста, введите вашу фамилию')]
          }, null, 8, ["modelValue", "rules"]),
          _createVNode(_component_s_input, {
            modelValue: _ctx.formData.firstName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.firstName) = $event)),
            label: "Имя",
            required: "",
            "lazy-rules": "ondemand",
            class: "q-mb-md s-input",
            clearable: "",
            rules: [_ctx.NotEmpty('Пожалуйста, введите ваше имя')]
          }, null, 8, ["modelValue", "rules"]),
          _createVNode(_component_s_input, {
            modelValue: _ctx.formData.middleName,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.middleName) = $event)),
            label: "Отчество",
            class: "q-mb-md s-input"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_s_input, {
            modelValue: _ctx.formData.email,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.email) = $event)),
            label: "email",
            required: "",
            "lazy-rules": "ondemand",
            class: "q-mb-md s-input",
            rules: [
          _ctx.NotEmpty('Пожалуйста, введите ваш email'),
          _ctx.ValidEmail('Необходимо корректно заполнить адрес электронной почты'),
        ]
          }, null, 8, ["modelValue", "rules"]),
          _createVNode(_component_s_input, {
            modelValue: _ctx.formData.phone,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.phone) = $event)),
            label: "Телефон",
            required: "",
            class: "q-mb-md s-input",
            clearable: "",
            "lazy-rules": "ondemand",
            mask: "+7 (###) ###-##-##",
            rules: [
          _ctx.NotEmpty('Пожалуйста, введите ваш номер телефона'),
          _ctx.ValidPhone('Телефон должен иметь следующий формат: +7 (900) 000-00-00'),
        ]
          }, null, 8, ["modelValue", "rules"]),
          _createVNode(_component_s_input, {
            modelValue: _ctx.formData.description,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.description) = $event)),
            label: "Комментарий",
            required: "",
            class: "q-mb-md",
            clearable: "",
            "lazy-rules": "ondemand",
            type: "textarea",
            rules: [
          _ctx.NotEmpty('Пожалуйста, введите ваш комментарий'),
          _ctx.MinLength(10, 'Минимальное количество символов: 10'),
        ]
          }, null, 8, ["modelValue", "rules"]),
          (_ctx.showCaptcha)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_yandex_captcha, { class: "s-mb-sm" }),
                (_ctx.banner.isBannerVisible.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      (_ctx.banner.isBannerVisible)
                        ? (_openBlock(), _createBlock(_component_s_banner, {
                            key: 0,
                            type: "error"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.banner.bannerText), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_s_btn, {
            class: "full-width q-mt-md",
            type: "brand",
            fat: "",
            loading: _ctx.loading.state.value,
            label: "Отправить",
            onClick: _ctx.onSubmit
          }, null, 8, ["loading", "onClick"])
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}